import { Outlet } from 'react-router-dom'

import { MyBenefitsRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/benefits/lib/CollectionsBootstrap'
import PageLoading from 'modules/layout/components/Page/Loading'

const Container = () => {
  const { data, loading } = useQuery(MyBenefitsRootPageDocument)

  const canSeeMyBenefits = data?.benefits._policies.sidebarSeeMyBenefitsTopLevelItem.can

  if (loading) {
    return <PageLoading />
  }

  return (
    <AuthorizeUser authorizeFn={() => canSeeMyBenefits ?? false}>
      <Outlet />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
